import dayjs, { ConfigType } from "dayjs"
import { DateFormatPreference } from "../types/DateFormatPreference"
import { ISODate } from "../types/ISODate"

export const formatShortDate = (
  date: ConfigType | ISODate | undefined,
  dateFormat: DateFormatPreference,
  defaultValue: string = "-"
): string => {
  if (!date) {
    return defaultValue
  }

  switch (dateFormat) {
    case DateFormatPreference.DayMonthYear:
      return dayjs(date).format("DD.MM.YYYY")

    case DateFormatPreference.MonthDayYear:
      return dayjs(date).format("MM.DD.YYYY")

    default:
      return dayjs(date).format("DD.MM.YYYY")
  }
}
